import React from "react";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form, FormInput, FormSelect, Button } from "shards-react";
import { Link } from "react-router-dom";
import UserDataService from "../../services/user.service";
import ProjectService from "../../services/project.service";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { FcPlus,FcList } from "react-icons/fc";
import { ToastContainer, toast } from "react-toastify";
import { actions as AppActions } from "../../_stores/app.store";
import authStore from "../../_stores/auth.store";

class CreateUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.getFormObject(),
      allProjects: [],
    };

    this.onFieldValueChanged = this.onFieldValueChanged.bind(this);
    this.onSwitchToggled = this.onSwitchToggled.bind(this);
    this.onChangeProject = this.onChangeProject.bind(this);
    this.handleAddUserForm = this.handleAddUserForm.bind(this);
    this.handleUpdateUserForm = this.handleUpdateUserForm.bind(this);
  }

  componentDidMount() {
    if (this.props.userId) this.retrieveUserDetails();
    else this.fetchProjects();
  }

  getFormObject() {
    return {
      name: "",
      email: "",
      ssoUser: true,
      password: "",
      role: "",
      active: true,
    };
  }

  fetchProjects(projList = []) {

    authStore.getState().auth_reducer.user.role === "superadmin" ?
      ProjectService.getAll().then((response) => {
        this.setState({
          allProjects: response.data.data.map((itm) => ({
            projectId: itm.id,
            projectName: itm.projectName,
            selected: projList.some((prl) => prl.projectId === itm.id) ? true : false,
          })),
        });
      })
    :
      UserDataService.getProjectsByEmail(authStore.getState().auth_reducer.user.email).then((response) => {
        this.setState({
          allProjects: response.data.data.projects.map((itm) => ({
            projectId: itm.projectId,
            projectName: itm.projectName,
            selected: projList.some((prl) => prl.projectId === itm.id) ? true : false,
          })),
        });
      });
  }

  retrieveUserDetails() {
    UserDataService.get(this.props.userId).then((response) => {
      var userDetails = response.data.data;
      this.setState({
        name: userDetails.name,
        email: userDetails.email,
        ssoUser: userDetails.ssoUser,
        password: "",
        role: userDetails.role,
        active: userDetails.active,
      });
      this.fetchProjects(userDetails.projects);
    });
  }

  onFieldValueChanged(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onSwitchToggled(e, key) {
    this.setState({
      [key]: e,
    });
  }

  onChangeProject(e, projId) {
    const projlist = this.state.allProjects.map((prj) => {
      if (prj.projectId === projId) prj.selected = e;
      return prj;
    });
    this.setState({
      allProjects: projlist,
    });
  }

  handleAddUserForm() {
    var payload = {
      name: this.state.name,
      email: this.state.email,
      ssoUser: this.state.ssoUser,
      password: !this.state.ssoUser ? this.state.password : "",
      role: this.state.role,
      projects: this.state.allProjects.filter((pr) => pr.selected),
      active: this.state.active,
    };
    AppActions.setLoading(true);
    UserDataService.create(payload).then((response) => {
      AppActions.setLoading(false);
      var notify_message = { type: "", message: "" };
      if (response.data.success) {
        notify_message.type = "success";
        notify_message.message = "User created successfully.";
        this.props.redirectToUserDetails("/view-users", notify_message);
      } else {
        if (response.data.err.name == "MongoError") {
          notify_message.type = "error";
          notify_message.message = "Duplicate email " + response.data.err.keyValue.email;
        } else {
          notify_message.type = "error";
          notify_message.message = response.data.message;
        }
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  handleUpdateUserForm() {
    const { userId } = this.props;
    var payload = {
      name: this.state.name,
      email: this.state.email,
      ssoUser: this.state.ssoUser,
      password: !this.state.ssoUser ? this.state.password : "",
      role: this.state.role,
      projects: this.state.allProjects.filter((pr) => pr.selected),
      active: this.state.active,
    };
    AppActions.setLoading(true);
    UserDataService.update(userId, payload).then((response) => {
      AppActions.setLoading(false);
      var notify_message = { type: "", message: "" };
      if (response.data.success) {
        notify_message.type = "success";
        notify_message.message = "User Updated successfully.";
        this.props.redirectToUserDetails("/view-users", notify_message);
      } else {
        if (response.data.err.name == "MongoError") {
          notify_message.type = "error";
          notify_message.message = response.data.err.message;
        } else {
          notify_message.type = "error";
          notify_message.message = response.data.message;
        }
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  //this is for showing notification
  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  render() {
    const { name, email, ssoUser, password, role, allProjects, active } = this.state;
    const { userId } = this.props;

    return (
      <div className="create-user">
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">{userId ? "Edit" : "Create"} User
              <Link className="btn btn-primary ml-4" to={"/view-users"}>
                <FcList /> View All
              </Link>
            </h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="name">Name</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <FormInput
                              id="name"
                              name="name"
                              placeholder="User Name"
                              value={name}
                              onChange={this.onFieldValueChanged}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="email">Email Id</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <FormInput
                              id="email"
                              name="email"
                              placeholder="Email ID"
                              value={email}
                              onChange={this.onFieldValueChanged}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="ssoUser">SSO User</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <BootstrapSwitchButton
                              checked={ssoUser}
                              id="ssoUser"
                              onlabel="Yes"
                              offlabel="No"
                              onChange={(e) => this.onSwitchToggled(e, "ssoUser")}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {!this.state.ssoUser ? (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="password">Password</label>
                        </Col>
                        <Col className="" md="8">
                          <Row>
                            <Col className="form-field" md="9">
                              <FormInput
                                id="pwd"
                                name="password"
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={this.onFieldValueChanged}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      <></>
                    )}

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="Role">Role</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <FormSelect id="role" name="role" value={role} onChange={this.onFieldValueChanged}>
                              <option value="">Select Role</option>
                              {authStore.getState().auth_reducer.user.role === "superadmin" && (
                                <option value="admin">Admin</option>
                              )}
                              <option value="user">User</option>
                            </FormSelect>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="Role">Projects</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            {allProjects.length ? (
                              allProjects.map((proj, inx) => (
                                <Row key={proj.projectId} className="mb-2">
                                  <Col md="2">
                                    <BootstrapSwitchButton
                                      checked={proj.selected}
                                      id={proj.projectId}
                                      onlabel="Yes"
                                      offlabel="No"
                                      onChange={(e) => this.onChangeProject(e, proj.projectId)}
                                    />
                                  </Col>
                                  <Col md="10">
                                    <div className="text-01">{proj.projectName}</div>
                                  </Col>
                                </Row>
                              ))
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="active">Active</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <BootstrapSwitchButton
                              checked={active}
                              id="active"
                              onlabel="Yes"
                              offlabel="No"
                              onChange={(e) => this.onSwitchToggled(e, "active")}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                        <Button
                          className="btn btn-primary float-left mr-3"
                          theme="accent"
                          onClick={userId ? this.handleUpdateUserForm : this.handleAddUserForm}
                        >
                          <FcPlus /> {userId ? "Update User" : "Create User"}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>
        <ToastContainer />
      </div>
    );
  }
}

export default CreateUser;
